<script>
export default {
  props: {
    value: { default: true },
    input: { default: false },
  },

  model: {
    prop: 'input',
  },

  methods: {
    toggle () {
      if (this.checked) {
        this.uncheck()
      } else {
        this.check()
      }
    },

    fire (value) {
      this.$emit('input', value)
    },

    check () {
      if (Array.isArray(this.input)) {
        this.fire(this.input.concat([this.value]))
      } else {
        this.fire(this.value)
      }
    },

    uncheck () {
      if (Array.isArray(this.input)) {
        this.fire(this.input.filter(item => item !== this.value))
      } else if (this.value === true) {
        this.fire(false)
      } else {
        this.fire(null)
      }
    }
  },

  computed: {
    checked () {
      if (Array.isArray(this.input)) {
        return this.input.includes(this.value)
      }

      return this.input === this.value
    },

    triggers () {
      return {
        click: this.toggle,
      }
    },
  },
}
</script>
